export default {
  lg: 1023,
  md: 639,
};



// WEBPACK FOOTER //
// ./scripts/utils/breakpoints.js